export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/publicity/images/query`,
          data
        });
      },

      save(data) {
          return http.json({
              url: '/publicity/images/save',
              data
          })
      },
      getInfo(data) {
          return http.json({
              url: `/publicity/images/get?id=${data.id}`
          })
      },
      /**
       * 删除版本
       * @param data
       * @return {*}
       */
      remove(data) {
          return http.json({
              url: `/publicity/images/delete?id=${data[0].id}`,
              data
          })
      },
      catlist(data){
        return http.json({
          url: `/knowledge/category/list`,
          data
        });
      },


  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/publicity.js